query allExtUltimateTeams(
  $first: Int,
  $offset: Int,
  $filter: UltimateTeamMappingFilter,
  ) {
  allUltimateTeamMappings(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      mappedEntity {
        name
        nodeId
        source
        teamId
      }
    }
    totalCount
  }
}
